export default "__VITE_ASSET__DYwSHkjT__"